import { ErrorAlert, Spinner } from '@lumlab/platform-ui';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { useAccess } from '@lumlab/platform-admin/web';
import { authClient } from './auth.ts';

const forbidden = { code: 'forbidden' };

export function RequireAdministrator({ children }: { children: ReactNode }) {
    const { t } = useTranslation();
    const session = authClient.useSession();
    const access = useAccess(session.data?.user.id);
    if (access.isPending)
        return (
            <div className="flex items-center justify-center p-8">
                <Spinner label={t('platform.shell.loading')} />
            </div>
        );
    if (access.error) return <ErrorAlert error={access.error} />;
    if (!access.data.administrator) return <ErrorAlert error={forbidden} />;
    return children;
}
